<template>
  <toast-notification ref="notification" />
  <loading-spinner
    ref="spinner"
    spinnerType="border"
    color="primary"
  ></loading-spinner>
  <site-modal
    ID="paySessionsModal"
    modalSize="semiMedium"
    :modalHasFooter="false"
    @Closed="closedPaySessionsModal"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6 v-if="!goTosessionsListSuccessfully">
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-all"
            viewBox="0 0 16 16"
          >
            <path
              d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"
            ></path>
          </svg>
          تسویه صورت حساب
        </h6>
        <h6 v-else>
          <i class="fi mdi-check"></i>
          ثبت موفق
        </h6>
      </div>
    </template>
    <template #body>
      <div v-if="!goTosessionsListSuccessfully">
        <div>
          <validation-summery
            v-if="checkoutInvoiceHasError"
            :errors="checkoutInvoiceModalError"
          ></validation-summery>

          <p class="mb-2" style="text-align: justify">
            صورت وضعیت جلسات شما به شرح زیر است:
          </p>
          <check-box-with-message
            title="از موجودی کیف پول استفاده شود"
            color="#506690"
            :disabled="selectedInvoiceList.walletBalance == 0"
            container-class="pb-2"
            v-model:checkBoxValue="useWallet"
            v-if="selectedInvoiceList.currencyTypeID == 1"
          />
          <div class="row" style="clear: both">
            <div class="col-8">
              <b :class="isMobile ? 'fs-7' : ''">مبلغ کل جلسات:</b>
            </div>
            <div class="col-4" :class="isMobile ? 'fs-7' : ''">
              {{
                this.thousandSeprator(
                  selectedInvoiceList.totalAmount,
                  ',',
                  '.'
                ) +
                ' ' +
                selectedInvoiceList.currencyName
              }}
            </div>
          </div>
          <div class="row">
            <div class="col-8">
              <b :class="isMobile ? 'fs-7' : ''">موجودی کیف پول:</b>
            </div>
            <div
              class="col-4"
              :class="selectedInvoiceList.totalAmount > 0 ? 'text-success' : ''"
            >
              <span :class="isMobile ? 'fs-7' : ''">
                {{
                  thousandSeprator(
                    selectedInvoiceList.walletBalance,
                    ',',
                    '.'
                  ) +
                  ' ' +
                  selectedInvoiceList.currencyName
                }}
              </span>
            </div>
          </div>
          <hr class="m-2" />
          <div class="row">
            <div class="col-8">
              <b :class="isMobile ? 'fs-7' : ''">مبلغ قابل پرداخت:</b>
            </div>
            <div class="col-4 text-danger" :class="isMobile ? 'fs-7' : ''">
              <template v-if="useWallet">
                {{
                  selectedInvoiceList.walletBalance -
                    selectedInvoiceList.totalAmount >
                  0
                    ? '0'
                    : thousandSeprator(
                        Math.abs(
                          selectedInvoiceList.walletBalance -
                            selectedInvoiceList.totalAmount
                        ),
                        ',',
                        '.'
                      )
                }}
                {{ selectedInvoiceList.currencyName }}
              </template>
              <template v-else>
                {{
                  thousandSeprator(selectedInvoiceList.totalAmount, ',', '.')
                }}
                {{ selectedInvoiceList.currencyName }}
              </template>
            </div>
            <div class="col-8" v-if="useWallet">
              <b :class="isMobile ? 'fs-7' : ''"
                >موجودی کیف پول پس از کسر مبلغ:</b
              >
            </div>
            <div
              class="col-4 text-danger"
              v-if="useWallet"
              :class="isMobile ? 'fs-7' : ''"
            >
              {{
                selectedInvoiceList.walletBalance -
                  selectedInvoiceList.totalAmount >
                0
                  ? thousandSeprator(
                      selectedInvoiceList.walletBalance -
                        selectedInvoiceList.totalAmount,
                      ',',
                      '.'
                    )
                  : '0'
              }}
              {{ selectedInvoiceList.currencyName }}
            </div>
          </div>
        </div>
        <div class="mt-4 text-center">
          <button class="btn btn-sm btn-danger" @click="payAndConfirmSessions">
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-bag-check"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
              <path
                d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
              ></path>
            </svg>
            پرداخت و ثبت
          </button>
        </div>
      </div>
      <div v-else>
        <p class="mb-2" style="text-align: justify">
          صورت وضعیت شما با موفقیت پرداخت شد و جلسات مورد نظر شما در لیست جلسات
          قرار گرفت.
        </p>
        <hr class="m-2" />
        <div class="mt-4 text-center">
          <button class="btn btn-sm btn-blueSite" @click="gotItResult">
            <svg
              class="float-start"
              width="18px"
              height="18px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
              ></path>
              <path
                fill-rule="evenodd"
                d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zm4.354 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
            </svg>
            لیست جلسات
          </button>
        </div>
      </div>
    </template>
  </site-modal>

  <site-modal
    ID="deleteConfirmation"
    modalSize="semiMedium"
    :modalHasFooter="false"
    @Closed="closedDeleteConfirmation"
  >
    <template #header>
      <div class="text-yellowTheme">
        <h6>
          <svg
            width="16px"
            height="16px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-trash"
            viewBox="0 0 16 16"
          >
            <path
              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            ></path>
          </svg>
          لغو صورت حساب
        </h6>
      </div>
    </template>
    <template #body>
      <div
        v-if="modalError.length != 0"
        class="text-danger bg-danger-soft p-2 rounded"
      >
        <p v-for="(item, index) in modalError" :key="index">• {{ item }}</p>
      </div>
      <div>
        <p class="mb-2" style="text-align: justify">
          آیا از لغو صورت حساب خود اطمینان دارید؟
        </p>
      </div>
      <div class="mt-4 d-flex justify-content-between">
        <button
          class="btn btn-sm btn-outline-blueSite"
          @click="confirmDeleteInvoice"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-check-lg"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
            ></path>
          </svg>
          بلی
        </button>
        <button
          class="btn btn-sm btn-outline-danger"
          @click="closedDeleteConfirmation"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            ></path>
          </svg>
          خیر
        </button>
      </div>
    </template>
  </site-modal>

  <div>
    <div class="text-secondary">
      <header-divider
        icon="fi fi-task-list"
        title="صورت حساب"
        class="m-2"
        v-if="!isMobile"
      >
      </header-divider>
    </div>

    <div v-if="clientHasInvoice && invoiceList.length != 0">
      <div class="m-2 mt-3">
        <p class="justified">
          <i class="fi fi-round-info-full text-danger-gradient blinkText"></i>
          در صورت عدم تسویه صورتحساب، جلسات انتخابی شما پس از
          <b><u>20 دقیقه</u></b> به صورت خودکار لغو می شود
        </p>
      </div>
      <div
        v-for="invoice in invoiceList"
        :key="invoice.id"
        :style="!isMobile ? 'max-height: 70vh; overflow: auto' : ''"
      >
        <div class="card border-secondary text-dark m-2">
          <h5 class="card-header bg-lightsecondary">
            <div class="d-flex justify-content-between">
              <div :class="isMobile ? 'fs-7' : ''">
                <b>شماره صورت حساب:</b>
                <small class="me-1">
                  {{ invoice.invoiceCode }}
                </small>
              </div>
              <div></div>
            </div>
          </h5>
          <div class="card-body p-0">
            <div class="row m-auto text-right p-3">
              <div class="col-md-6 col-12">
                <h6 :class="isMobile ? 'fs-8' : ''">
                  وضعیت:
                  <b>{{ invoice.invoiceStatusTypeTitle }}</b>
                </h6>
              </div>
              <div class="col-md-6 col-12">
                <h6 :class="isMobile ? 'fs-8' : ''">
                  تعداد جلسات:
                  <b v-if="loadComplete">{{ invoice.invoiceItems?.length }}</b>
                </h6>
              </div>
              <div class="col-md-6 col-12">
                <h6 :class="isMobile ? 'fs-8' : ''">
                  تاریخ:
                  <b>
                    {{ getPersianDate(invoice.invoiceDateTime) }}
                  </b>
                </h6>
              </div>
              <div class="col-md-6 col-12" v-if="isOverseas()">
                <h6 :class="isMobile ? 'fs-8' : ''">
                  تاریخ(میلادی):
                  <b class="gregorianDateClass" style="unicode-bidi: isolate">
                    {{ getGregorianDateOfSession(invoice.invoiceDateTime) }}
                  </b>
                </h6>
              </div>

              <div class="col-md-9 col-12">
                <h6 :class="isMobile ? 'fs-8' : ''">
                  مبلغ کل:
                  <b
                    >{{ thousandSeprator(invoice.totalAmount, ',', '.') }}
                    {{ invoice.currencyName }}</b
                  >
                </h6>
              </div>
            </div>
            <div class="row m-2">
              <div class="col-md-4">
                <button
                  class="btn btn-sm btn-danger text-white"
                  @click="showPaySessionsModal(invoice)"
                  :class="isMobile ? 'p-1 fs-7' : ''"
                >
                  آماده پرداخت
                </button>
                <button
                  class="btn btn-sm btn-outline-danger"
                  @click="deleteButtonClick"
                  :class="isMobile ? 'p-1 fs-7' : ''"
                >
                  <svg
                    width="18px"
                    height="18px"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    ></path>
                  </svg>
                  لغو
                </button>
              </div>
            </div>
            <!-- <div class="card">
              <div
                class="card-header border-0 p-0 border bg-transparent"
                id="cleanHeadingBorder5"
              >
                <h4 class="mb-0">
                  <button
                    class="btn bg-gray-200 shadow w-100 btn-lg text-align-center text-decoration-none text-blueSite collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#shadowCollapse`"
                    aria-expanded="false"
                    aria-controls="shadowCollapse"
                    :class="isMobile ? 'fs-8' : ''"
                  >
                    جزئیات صورت حساب
                    <span class="group-icon me-2">
                      <i class="fi fi-arrow-down-slim"></i>
                      <i class="fi fi-arrow-up-slim"></i>
                    </span>
                  </button>
                </h4>
              </div>
              <div
                :id="`shadowCollapse`"
                class="collapse mt-1 scrollable-styled-dark show"
                :style="!isMobile ? 'max-height: 40vh; overflow: auto' : ''"
                aria-labelledby="cleanHeadingBorder"
                data-bs-parent="#accordionBottomBorder"
              >
                <div
                  v-for="(invoiceItem, index) in invoice.invoiceItems"
                  :key="invoiceItem.id"
                  class="card border-secondary text-dark m-2"
                >
                  <h5
                    class="card-header p-1 px-2"
                    :class="
                      invoiceItem.relatedSessionCancled
                        ? 'bg-danger-soft'
                        : 'bg-gray-300'
                    "
                  >
                    <div class="d-flex justify-content-between">
                      <div :class="isMobile ? 'fs-7' : ''">
                        #{{ index + 1 }}
                        {{
                          invoiceItem.relatedSessionCancled ? '(لغو شده)' : ''
                        }}
                      </div>
                    </div>
                  </h5>
                  <div class="card-body">
                    <div class="row m-auto text-right">
                      <div class="col-md-6 col-12">
                        <h6 :class="isMobile ? 'fs-8' : ''">
                          تاریخ جلسه:
                          <b>
                            {{ getPersianDate(invoiceItem.sessionDate) }}
                          </b>
                        </h6>
                      </div>

                      <div class="col-md-6 col-12">
                        <h6 :class="isMobile ? 'fs-8' : ''">
                          ساعت:
                          <b dir="ltr"
                            >{{ getHourAndMinute(invoiceItem.fromTime) }} -
                            {{ getHourAndMinute(invoiceItem.toTime) }}</b
                          >
                        </h6>
                      </div>
                      <div class="col-md-6 col-12">
                        <h6 :class="isMobile ? 'fs-8' : ''">
                          نوع برگزاری:
                          <b>{{ invoiceItem.sessionType }}</b>
                        </h6>
                      </div>
                      <div class="col-md-6 col-12">
                        <h6 :class="isMobile ? 'fs-8' : ''">
                          سرپرست گروه:
                          <b>{{ invoiceItem.therapist }}</b>
                        </h6>
                      </div>
                      <div class="col-md-6 col-12">
                        <h6 :class="isMobile ? 'fs-8' : ''">
                          نوع جلسه:
                          <b>{{ invoiceItem.therapyType }}</b>
                        </h6>
                      </div>
                      <div class="col-md-6 col-12" v-if="isOverseas()">
                        <h6 :class="isMobile ? 'fs-8' : ''">
                          تاریخ جلسه(میلادی):
                          <b
                            class="gregorianDateClass"
                            style="unicode-bidi: isolate"
                          >
                            ({{
                              getGregorianDateOfSession(
                                invoiceItem.sessionDate
                              )
                            }})
                          </b>
                        </h6>
                      </div>

                      <div class="col-md-6 col-12">
                        <h6 :class="isMobile ? 'fs-8' : ''">
                          قیمت:
                          <b
                            >{{
                              thousandSeprator(
                                invoiceItem.totalItemAmount,
                                ',',
                                '.'
                              )
                            }}
                            {{ invoice.currencyName }}
                          </b>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';

import { isMobile } from 'mobile-device-detect';
import { Modal } from 'bootstrap';
import axios from 'axios';
import HeaderDivider from '../../../../components/utility/headerDivider/HeaderDivider.vue';
import ValidationSummery from '../../../../components/form/errorBox/ValidationSummery.vue';
import CheckBoxWithMessage from '../../../../components/form/checkBoxWithMessage/CheckBoxWithMessage.vue';
export default {
  components: {
    LoadingSpinner,
    HeaderDivider,
    ValidationSummery,
    CheckBoxWithMessage,
  },
  inject: ['WalletList', 'RefreshWalletList'],
  data() {
    return {
      clientHasInvoice: true,
      loadComplete: false,
      isMobile: isMobile,
      checkoutInvoiceHasError: false,
      goTosessionsListSuccessfully: false,
      checkoutInvoiceModalError: [],
      modalHasError: false,
      walletList: [],
      useWallet: false,
      modalError: [],
      invoiceList: new Array(),

      paySessionsModal: new Object(),
      deleteConfirmation: new Object(),
      selectedInvoiceList: new Object({
        currencyName: '',
        totalAmount: 0,
        walletBalance: 0,
        invoiceItems: [],
      }),
    };
  },
  methods: {
    getHourAndMinute(data) {
      return `${data.split(':')[0]}:${data.split(':')[1]}`;
    },
    getPersianDate(date) {
      // eslint-disable-next-line
      return new persianDate(new Date(date)).format('L');
    },
    getGregorianDateOfSession(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    isOverseas() {
      return this.$store.getters.isOverseas == true;
    },
    thousandSeprator(number, seprator, decimalPointer) {
      // eslint-disable-next-line
      return thousandSeprator(number, seprator, decimalPointer);
    },
    showPaySessionsModal(invoice) {
      this.selectedInvoiceList = invoice;
      this.paySessionsModal.show();
    },
    closedPaySessionsModal() {
      this.paySessionsModal.hide();
      this.useWallet = false;
      this.checkoutInvoiceHasError = false;
      this.checkoutInvoiceModalError = [];
    },
    getClientPhoneEmail() {
      return this.$store.getters.phone ?? this.$store.getters.email ?? '';
    },
    async payAndConfirmSessions() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .post('/FN/InvoiceHeader/CheckoutInvoiceForSite', {
          invoiceHeaderID: that.selectedInvoiceList.id,
          clientName: that.$store?.getters?.userFullName,
          clientPhoneEmail: that.getClientPhoneEmail(),
          useWalletBalance: that.useWallet,
          description: '',
        })
        .then(async (response) => {
          if (!response.data?.success) {
            that.checkoutInvoiceHasError = true;
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            that.checkoutInvoiceModalError = errorMessages;
            return;
          }
          //اگر پاسخ حاوی لیینک پرداخت بود، به صفحه پرداخت هدایت شود
          if (response.data.success && response.data.returnValue) {
            window.location.href = response.data.returnValue;
            return;
          }

          that.$refs.notification.show({
            type: 'success',
            title: `صورت حساب شما با موفقیت تسویه شد.`,
          });
          that.goTosessionsListSuccessfully = true;
          that.clearSemiReserveList();
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `تسویه صورت حساب جلسات با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    deleteButtonClick() {
      this.deleteConfirmation.show();
    },
    closedDeleteConfirmation() {
      this.deleteConfirmation.hide();
    },
    async confirmDeleteInvoice() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .post(
          `/CLC/WorkshopGroupSessionPerson/CancelReservationSessionByPerson/${this.$store.getters.userPersonID}`
        )
        .then(async (response) => {
          if (!response.data?.success) {
            let errorMessages = response.data.errors.map((i) => i.errorMessage);
            errorMessages.forEach((item) => {
              this.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            that.modalError = errorMessages;
            return;
          }
          if (response.data.success) {
            that.$refs.notification.show({
              type: 'success',
              title: `صورت حساب شما با موفقیت حذف شد.`,
            });
          }
          this.$router.push({
            name: 'workshopTab',
            params: {
              id: this.$store.getters.userPersonID,
              type: 1,
            },
          });
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `حذف صورت حساب با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
          that.closedDeleteConfirmation();
        });
    },

    gotItResult() {
      this.closedPaySessionsModal();
      this.$router.push({
        name: 'sessionsTab',
        params: { id: this.$store.getters.userPersonID },
      });
    },
  },
  async mounted() {
    let that = this;
    await this.RefreshWalletList();
    that.walletList = that.WalletList();
    that.$refs.spinner.show();
    await axios
      .get(
        `/FN/InvoiceHeader/GetAllWorkshopInvoicesForCheckout?personID=${that.$store.getters.userPersonID}`
      )
      .then((response) => {
        if (response.data == '') that.clientHasInvoice = false;

        if (response.data.length != 0) {
          if (that.walletList.length == 0) return;
          if (
            that.walletList.find(
              (f) => f.currencyTypeID == response.data[0].currencyTypeID
            ).balance != 0
          )
            that.useWallet = true;
          that.invoiceList = response.data;
          that.invoiceList.forEach((inv) => {
            if (inv.invoiceItems.every((item) => item.relatedSessionCancled)) {
              that.invoiceList = that.invoiceList.filter((item) => {
                return item.id != inv.id;
              });
            }
          });
          that.loadComplete = true;
        }
      })
      .catch(() => {
        this.$refs.notification.show({
          type: 'error',
          title: `عملیات دریافت صورت حساب شما با خطا مواجه گردید..`,
        });
      })
      .finally(() => {
        that.$refs.spinner.hide();
      });
    this.paySessionsModal = new Modal(
      document.getElementById('paySessionsModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );

    this.deleteConfirmation = new Modal(
      document.getElementById('deleteConfirmation'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
  },
};
</script>
